import { useState } from "react";
import ReactQuill from "react-quill";
import { formats, modules } from "./toolbarOptions";

import 'react-quill/dist/quill.snow.css';
import './index.scss';

// Temporary React 19 compatibility fallback:
// react-quill's readOnly mount path uses findDOMNode internally, which throws in React 19.
// Keep the previous ReactQuill readOnly implementation commented below for future migration.
type IProps = {
  source: string,
  label?: string;
  onChange?:(html: string) => void,
  readOnly?: boolean
}

const CustomEditor = ({ source, label, onChange, readOnly = false }: IProps) => {
  const [value, setValue] = useState(source);

  const handleChange = (content: string, delta: any, source: any, editor: any) => {
    setValue(content);
    const html = editor.getHTML();
    onChange?.(html);
  };

  if (readOnly) {
    return (
      <div className="quill-readonly-container">
        {label? <label className="quill-label">{label}</label> : null}
        <div className="ql-container">
          <div className="ql-editor" dangerouslySetInnerHTML={{ __html: value || '' }} />
        </div>
        {/* <ReactQuill
          value={value}
          readOnly={true}
          theme=""
          modules={{ toolbar: false }}
          style={{
            border: 'none',
            padding: 0
          }}
        /> */}
      </div>
    );
  }

  return (
    <>
      {label? <label className="quill-label">{label}</label> : null}
      <ReactQuill
        theme="snow"
        value={value}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        style={{
          height: "350px"
        }}
        preserveWhitespace={true}
      />
    </>
  );
};

export default CustomEditor;
